import { IApplyForPublicationRequest, IMappers } from '../../../repositories/coworking/v1/apply-for-publication';
import { IApplicationContext } from '../../../types/applicationContext';

export enum EApplyForPublicationStatus {
  CriticalError,
  Error,
  Pending,
  Success,
}

export interface IApplyForPublicationStatus {
  /** Статус платежа */
  status: EApplyForPublicationStatus;
  /** Поясняющий текст */
  message?: string;
}

export interface IPostApplyForPublicationStatusDependencies extends Pick<IApplicationContext, 'logger' | 'httpApi'> {
  parameters: IApplyForPublicationRequest;
}

export type PostApplyFormPublicationsMappers = IMappers<IApplyForPublicationStatus, IApplyForPublicationStatus>;
